import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types"
import { toggleContact } from '../../state/actions';
import { NavItem, SearchButton, GlobalSearch } from '../'
import style from './style.module.scss'

const NavList = (props) => {

    const handleContactButton = () => {
        props.dispatch(toggleContact(true, 'bimbo'))
    }

    return (
        <ul className={style.listWrapper}>
            <span>
                <NavItem link="/">HOME</NavItem>
                <NavItem link="/products">PRODUCTS</NavItem>
                <NavItem link="/recipes">RECIPES</NavItem>
                <NavItem link="/events">EVENTS</NavItem>
                <NavItem link="/meet-bimbo">MEET BIMBO</NavItem>
                <NavItem link="/school-program">SCHOOL PROGRAM</NavItem>
                <span className={style.navItem} onClick={handleContactButton}>CONTACT</span>
            </span>
            <div className={style.searchWrapper}>
                <GlobalSearch />
                <SearchButton />
            </div>
        </ul>
    )
}

NavList.propTypes = {
    vertical: PropTypes.bool,
    hAlign: PropTypes.string,
    vAlign: PropTypes.string
}

NavList.defaultProps = {
    vertical: false,
    hAlign: 'center',
    vAlign: 'center',
}

export default connect()(NavList);